/**
 * The "À faire" / "À éviter" guidelines are stored as one string
 * (`BriefGuidelines.dos` / `donts`) and edited as a list: each item the brand
 * types is exactly one row the creator reads, in the same order.
 *
 * Writing joins items with a line break. Reading splits on line breaks AND on
 * "·", so briefs saved before the list editor (" · " separated) and AI drafts
 * open as items. The creator portal splits the same way, which is what keeps
 * the mapping one to one, at the price of a "·" typed inside an item reading
 * as two items.
 */

/** Line breaks (any platform) and the legacy middle-dot separator. */
const GUIDELINE_SEPARATOR = /\r\n|\r|\n|·/;

/**
 * Per-item cap. The backend sets no length on dos/donts; a row the creator
 * reads at a glance stays well under a short paragraph.
 */
export const GUIDELINE_ITEM_MAX_LENGTH = 200;

/** Stored value to items: trimmed, empties dropped. */
export const parseGuidelineItems = (value: string): string[] =>
  value
    .split(GUIDELINE_SEPARATOR)
    .map((item) => item.trim())
    .filter((item) => item.length > 0);

/** Items to stored value: trimmed, empties dropped, one per line. */
export const serializeGuidelineItems = (items: readonly string[]): string =>
  items
    .map((item) => item.trim())
    .filter((item) => item.length > 0)
    .join('\n');

/** Whether pasted text holds several items and must be spread over rows. */
export const holdsSeveralGuidelineItems = (text: string): boolean => GUIDELINE_SEPARATOR.test(text);
